import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LineController,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(LineElement, PointElement, LineController, CategoryScale, LinearScale, Title, Tooltip, Legend);

const ShowYearlyGraph = ({ performanceGraphDetails,avarage }) => {
    const graphPoints = performanceGraphDetails;
    if (!Array.isArray(graphPoints) || graphPoints.length === 0) {
        return null;
    }
    // Data is already reversed in YearlyGraph.jsx to oldest->newest
    // Don't reverse again here

    // Generate labels from month and year fields
    const labels = graphPoints?.map((point, index) => {
        // Use month and year fields directly from database
        if (point.month && point.year) {
            const month = point.month;
            const year = point.year.toString().slice(-2);
            return `${String(month).padStart(2, '0')}/${year}`;
        }
        return '';
    });
    // Calculate cumulative values from amount within 12-month window (starting at 0)
    // This EXACTLY matches what clients see in the Flutter app
    // Steeper incline for good months (e.g., +4.91%), flatter for small months (e.g., +0.17%)
    const getNormalizedPoint = (point, idx) => {
        // Calculate cumulative from amount values within 12-month window
        // Start at 0 for first month, then add each month's amount cumulatively
        let cumulativeTotal = 0;
        for (let i = 0; i <= idx; i++) {
            cumulativeTotal += parseFloat(graphPoints[i]?.amount || 0);
        }
        
        // Return cumulative value (already starts at 0 for first month)
        // This ensures graph steepness reflects each month's performance correctly
        return cumulativeTotal;
    };

    const data = {
        labels: labels,
        datasets: [
            {
                label: `Performance ${avarage} %`,
                data: graphPoints?.map((point, idx) => getNormalizedPoint(point, idx)),
                borderColor: '#4ade80',
                backgroundColor: 'rgba(74, 222, 128, 0.15)',
                tension: 0.3,
                
                fill: true,
                pointStyle: 'circle',
                pointRadius: 5,
                pointHoverRadius: 10,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    font: {
                        size: 16,
                        weight:600
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const point = graphPoints[tooltipItem?.dataIndex];
                        const normalizedValue = tooltipItem.parsed.y;
                        const monthlyAmount = parseFloat(point?.amount || 0);
                        return `Cumulative: ${normalizedValue.toFixed(2)}% | Monthly: ${monthlyAmount.toFixed(2)}%`;
                    },
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Months',
                },
            },
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                },
                ticks: {
                    callback: function (value) {
                        return `${value.toFixed(2)}%`;
                    },
                },
            },
        },
    };

    return (
        <div style={{ width: '100%', height: '500px' }}>
            <Line data={data} options={options} />
        </div>
    );
};

export default ShowYearlyGraph;